export const CursosHero = () => {
	return (
		<div className="mb-16 text-center space-y-6">
			<h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight animate-slide-down">
				Cursos para o Mercado Imobiliário
			</h1>
			<p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed animate-slide-up stagger-1">
				Invista na sua carreira com cursos desenvolvidos por especialistas do
				setor imobiliário. Conteúdo prático, atualizado e focado em resultados
				para você se destacar no mercado.
			</p>
		</div>
	);
};
